import React, { Component } from "react";

class Hero2 extends Component {
  render() {
    return (
      <section className="wpo-hero-section-1" style={{background: "#232f4b"}}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-7 col-lg-7">
              <div className="wpo-hero-section-text">
                <div className="wpo-hero-title-top">
                  <span className="text-white">Conheça a Thomas Talent RH</span>
                </div>
                <div className="wpo-hero-title" >
                  <h2 className="text-white">Fazendo sua ideia de negócios se tornar realidade</h2>
                </div>
                <div className="wpo-hero-subtitle">
                  <p className="text-white">
                    Facilitamos o aprendizado dos nossos clientes, trazendo as pessoas certas para o lugar certo.
                  </p>
                </div>
                <div className="btns">
                  <a
                    href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                    target="_blank"
                    rel="noreferrer"
                    className="btn theme-btn"
                  >
                    Fale conosco
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-img"></div>
      </section>
    );
  }
}

export default Hero2;
